import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Mapped } from "@omni/utils/context/mapped.context";
import { isDefined } from "@omni/utils/helper.utils";
import { createContext, use } from "react";

import { FeatureInfo } from "@/components/PaintConfigurator/paintConfigurator.types";

type FinishesContextValue = {
    finishes: Array<FeatureInfo>;
};

type FinishesContextProviderProps = RequireChildrenFor<{
    finishes?: Map<string, FeatureInfo>;
}>;

export const FinishesContext = createContext<FinishesContextValue | undefined>(
    undefined
);
FinishesContext.displayName = "FinishesContext";

export const FinishesContextProvider = ({
    finishes = new Map<string, FeatureInfo>(),
    children
}: FinishesContextProviderProps) => {
    return (
        <FinishesContext value={{ finishes: Array.from(finishes.values()) }}>
            <Mapped array={Array.from(finishes.keys())}>{children}</Mapped>
        </FinishesContext>
    );
};

export const useFinishesContext = () => {
    const context = use<FinishesContextValue | undefined>(FinishesContext);

    if (!isDefined(context)) {
        throw new Error(`${FinishesContext.displayName} is undefined.`);
    }

    return context;
};
